import { render, staticRenderFns } from "./ModalSetDifficult.vue?vue&type=template&id=072230c3&lang=pug&"
import script from "./ModalSetDifficult.vue?vue&type=script&lang=ts&"
export * from "./ModalSetDifficult.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSetDifficult.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports